import { render } from "./GalleryView.vue?vue&type=template&id=35aafd38&scoped=true&ts=true"
import script from "./GalleryView.vue?vue&type=script&lang=ts"
export * from "./GalleryView.vue?vue&type=script&lang=ts"

import "./GalleryView.vue?vue&type=style&index=0&id=35aafd38&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aafd38"]])

export default __exports__